<template>
    <section class="leads-section-wrapper">
        <div class="section-header">
            <h4>{{$t("message.leads")}}</h4>
        </div>

        <div v-if="leads.length" class="leads-section">
            <div v-for="lead in leads" :key="lead.id" class="lead-row">
                <div class="lead-info">
                    <div class="lead-name">
                        <i class="material-icons">person</i>
                        <span>{{ lead.Full_Name }}</span>
                    </div>
                    <div class="lead-date">
                        <i class="material-icons">event</i>
                        <span>{{ formatDate(lead.Created_Time) }}</span>
                    </div>
                    <div class="lead-footer">
                        <div class="lead-owner">
                            <i class="material-icons">person</i>
                            <span>{{ lead.Owner.name }}</span>
                        </div>
                        <div class="lead-status" v-if="lead.Lead_Status">
                            <i class="material-icons">label</i>
                            <span>{{ lead.Lead_Status }}</span>
                        </div>
                    </div>
                    <div class="lead-layout">
                        <i class="material-icons">category</i>
                        <span>{{ $_.get(lead, "Layout.name", "Defualt Layout") }}</span>
                    </div>
                </div>
                <SupsisButton class="view-lead-btn" icon="open_in_new" @click="gotoLeadOnZoho(lead.id)" />
                <a-divider />
            </div>
        </div>

        <div v-else-if="loading" class="loading-container">
            <span>Loading leads</span>
            <BucketSpinner class="large-spinner" />
        </div>

        <div v-else class="empty-leads-container">
            <span class="material-icons empty-icon">person_off</span>
            <p class="empty-text">{{ $t("message.noLeadsFound") }}</p>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import { ZOHO_API } from "../../../../api/zoho";
import { mapState } from "vuex";
import BucketSpinner from "../../../../views/Reports/common/spinners/BucketSpinner.vue";
import SupsisButton from "../../../../views/Pages/Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "ZohoLeadsSection",
    components: {
        BucketSpinner,
        SupsisButton,
    },
    props: {
        contact: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState({
            zohoChannelExists: (state) => !!state.channel.channels.find((x) => x.type === "zoho"),
            zohoChannel: (state) => state.channel.channels.find((x) => x.type === "zoho"),
        }),
    },
    data() {
        return {
            leads: [],
            loading: false,
        };
    },
    async created() {
        await this.fetchLeads();
    },
    methods: {
        async fetchLeads() {
            this.loading = true;
            try {
                const contactId = this.contact._id;
                const phone = this.contact.whatsappNumber || this.contact.phone;
                const leads = await ZOHO_API.searchRecordsByPhone("Leads", phone);
                if (this.contact?._id === contactId) {
                    this.leads = Array.isArray(leads) ? leads : [];
                }
            } catch (error) {
                console.error("Error loading leads:", error);
            } finally {
                this.loading = false;
            }
        },
        formatDate(dateString) {
            if (!dateString) return "";
            return new Date(dateString).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
            });
        },
        gotoLeadOnZoho(leadId) {
            const orgId = _.get(this.zohoChannel, "payload.organization.domain_name");
            if (orgId && leadId) {
                window.open(`https://crm.zoho.com/crm/${orgId}/tab/Leads/${leadId}`, "_blank");
            }
        },
    },
    watch: {
        contact: {
            handler() {
                this.leads = [];
                this.fetchLeads();
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.leads-section-wrapper {
    .section-header {
        margin-bottom: 12px;

        h4 {
            font-size: 16px;
            font-weight: 500;
            color: #4a5568;
            margin: 0;
        }
    }

    .leads-section {
        .lead-row {
            position: relative;
            padding: 12px;

            .lead-info {
                .lead-name,
                .lead-date,
                .lead-footer > div,
                .lead-layout {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-bottom: 4px;

                    i.material-icons {
                        font-size: 18px;
                        color: #64748b;
                    }
                }

                .lead-name {
                    font-weight: 500;
                    font-size: 15px;
                    color: #2d3748;
                }

                .lead-footer {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 0.9em;

                    .lead-owner {
                        color: #718096;
                    }

                    .lead-status {
                        display: inline-flex;
                        background: #e2e8f0;
                        padding: 2px 8px;
                        border-radius: 12px;
                        font-size: 0.85em;
                        color: #4a5568;
                    }
                }

                .lead-layout {
                    font-size: 0.85em;
                    color: #94a3b8;
                }
            }

            .view-lead-btn {
                position: absolute;
                top: 12px;
                right: 12px;
            }
        }
    }

    .loading-container,
    .empty-leads-container {
        min-height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        color: #94a3b8;

        .empty-icon {
            font-size: 36px;
            margin-bottom: 8px;
        }

        .empty-text {
            font-size: 14px;
            text-align: center;
            margin: 0;
        }
    }
}
</style>
